/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_8_TitleInputs */

const et_portfolio_project_8_title = /** @type {(inputs: Portfolio_Project_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohalik nähtavus ja kaasatus kasvasid 90 päevaga.`)
};

const en_portfolio_project_8_title = /** @type {(inputs: Portfolio_Project_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increased local visibility and engagement within 90 days.`)
};

/**
* | output |
* | --- |
* | "Increased local visibility and engagement within 90 days." |
*
* @param {Portfolio_Project_8_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_8_title = /** @type {((inputs?: Portfolio_Project_8_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_8_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_8_title(inputs)
	return en_portfolio_project_8_title(inputs)
});